import { HashRouter as BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage/LandingPage';
import DemoSelection from './components/DemoSelection/DemoSelection';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/demo" element={<DemoSelection />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
